/* KidoBook — smooth AJAX cart + slide-in drawer.
   Intercepts every add-to-cart form (product page + book cards), adds via the
   Cart AJAX API without reloading, then opens a drawer with the updated cart. */
(function () {
  'use strict';
  if (window.__ktCartBooted) return;
  window.__ktCartBooted = true;

  var doc = document;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = function () { return doc.querySelector('[data-kt-cart-drawer]'); };

  function money(cents, code) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code || 'USD' }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function esc(s) { var d = doc.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ----- Render the drawer from a cart object ----- */
  function render(cart) {
    var d = drawer(); if (!d) return;
    var items = d.querySelector('[data-kt-cart-items]');
    var empty = d.querySelector('[data-kt-cart-empty]');
    var foot = d.querySelector('[data-kt-cart-foot]');
    var count = cart.item_count || 0;

    // counts everywhere
    doc.querySelectorAll('.kt-badge, [data-kt-cart-count]').forEach(function (el) { el.textContent = count; });
    doc.querySelectorAll('[data-kt-cart-count-label]').forEach(function (el) { el.textContent = '(' + count + ')'; });

    if (empty) empty.hidden = count > 0;
    if (foot) foot.hidden = count === 0;

    if (items) {
      if (count === 0) { items.innerHTML = ''; }
      else {
        items.innerHTML = cart.items.map(function (it) {
          var img = (it.image || (it.featured_image && it.featured_image.url) || '');
          var imgTag = img ? '<img class="kt-cartline__img" src="' + img.replace(/(\.[a-z]+)(\?|$)/i, '_120x160$1$2') + '" alt="" loading="lazy">' : '<span class="kt-cartline__img"></span>';
          var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<span class="kt-cartline__variant">' + esc(it.variant_title) + '</span>' : '';
          return '<div class="kt-cartline" data-key="' + esc(it.key) + '">' +
            imgTag +
            '<div class="kt-cartline__mid">' +
              '<span class="kt-cartline__title"><a href="' + it.url + '">' + esc(it.product_title) + '</a></span>' +
              variant +
              '<span class="kt-cartline__qty" data-key="' + esc(it.key) + '">' +
                '<button type="button" data-kt-qty="-1" aria-label="Decrease">&minus;</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-kt-qty="1" aria-label="Increase">+</button>' +
              '</span>' +
            '</div>' +
            '<div class="kt-cartline__right">' +
              '<span class="kt-cartline__price">' + money(it.final_line_price, cart.currency) + '</span>' +
              '<button type="button" class="kt-cartline__remove" data-kt-remove="' + esc(it.key) + '">Remove</button>' +
            '</div>' +
          '</div>';
        }).join('');
      }
    }
    var sub = d.querySelector('[data-kt-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price, cart.currency);
  }

  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function open() { var d = drawer(); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); doc.body.style.overflow = 'hidden'; }
  function close() { var d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); doc.body.style.overflow = ''; }
  function bump() { doc.querySelectorAll('.kt-badge, [data-kt-cart-count]').forEach(function (el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }); }

  /* ----- Add to cart ----- */
  function addToCart(form, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw res.body; }
        return getCart();
      })
      .then(function (cart) {
        render(cart); bump(); open();
        if (btn) {
          btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
          var label = btn.querySelector('[data-kb-atc-label]') || btn;
          var prev = label.textContent;
          btn.classList.add('is-done'); label.textContent = 'Added ✓';
          setTimeout(function () { btn.classList.remove('is-done'); label.textContent = prev; }, 1400);
        }
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart.';
        // Fallback: let the form submit normally so the shopper is never stuck.
        try { window.alert(msg); } catch (e) {}
      });
  }

  /* ----- Change quantity / remove ----- */
  function change(key, qty) {
    var d = drawer(); if (d) d.classList.add('is-loading');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); bump(); })
      .catch(function () {})
      .then(function () { if (d) d.classList.remove('is-loading'); });
  }

  /* ----- Wire up (event delegation, survives re-render) ----- */
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action$="/cart/add"], form[action*="/cart/add"]')) {
      e.preventDefault();
      addToCart(form, form.querySelector('[type="submit"], button:not([type])'));
    }
  });

  doc.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-kt-cart-open], a[href$="/cart"]');
    if (openEl && drawer() && !openEl.closest('[data-kt-cart-drawer]')) { e.preventDefault(); getCart().then(function (c) { render(c); open(); }); return; }
    if (e.target.closest('[data-kt-cart-close]')) { e.preventDefault(); close(); return; }
    var rm = e.target.closest('[data-kt-remove]');
    if (rm) { e.preventDefault(); var line = rm.closest('.kt-cartline'); if (line) line.classList.add('is-removing'); change(rm.getAttribute('data-kt-remove'), 0); return; }
    var q = e.target.closest('[data-kt-qty]');
    if (q) {
      e.preventDefault();
      var wrap = q.closest('[data-key]'); if (!wrap) return;
      var cur = parseInt(wrap.querySelector('span').textContent, 10) || 1;
      var next = cur + parseInt(q.getAttribute('data-kt-qty'), 10);
      if (next < 0) next = 0;
      change(wrap.getAttribute('data-key'), next);
    }
  });

  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  doc.addEventListener('cart:refresh', function (e) {
    getCart().then(function (cart) {
      render(cart); bump();
      if (e.detail && e.detail.open) open();
    }).catch(function () {});
  });

  // Sticky-bar "add" button submits the main product form → caught above.
})();
